module.exports = __webpack_public_path__ + "static/media/multan-dark.f18970f0.svg";